module.exports = __webpack_public_path__ + "d1ae809e6dd2afa78ea62a83e638d46b.jpg";